export interface EmailsSeparados {
  validos: string[];
  invalidos: string[];
}

export interface FalhaEnvio {
  email: string;
  mensagem: string;
}

const FORMATO_EMAIL = /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/;

/**
 * Separa um texto com um ou vários e-mails (vírgula, ponto e vírgula, quebra de linha ou espaço),
 * remove vazios e repetidos (sem diferenciar maiúsculas; vale a 1ª grafia) e divide em válidos/inválidos.
 */
export const separarEmails = (texto: string): EmailsSeparados => {
  const vistos = new Set<string>();
  const validos: string[] = [];
  const invalidos: string[] = [];
  for (const parte of texto.split(/[,;\s]+/)) {
    const email = parte.trim();
    if (!email) continue;
    const chave = email.toLowerCase();
    if (vistos.has(chave)) continue;
    vistos.add(chave);
    (FORMATO_EMAIL.test(email) ? validos : invalidos).push(email);
  }
  return { validos, invalidos };
};

/** Parte do e-mail antes do @ — usada como nome quando se cadastram várias pessoas de uma vez. */
export const nomeDoEmail = (email: string): string => email.split("@")[0];

/** Executa `enviar` para cada e-mail, um por vez (nunca em paralelo), e junta quem deu certo e quem falhou. */
export const enviarEmSequencia = async (
  emails: string[],
  enviar: (email: string) => Promise<unknown>,
  mensagemDaFalha: (erro: unknown) => string
): Promise<{ enviados: string[]; falhas: FalhaEnvio[] }> => {
  const enviados: string[] = [];
  const falhas: FalhaEnvio[] = [];
  for (const email of emails) {
    try {
      await enviar(email);
      enviados.push(email);
    } catch (e) {
      falhas.push({ email, mensagem: mensagemDaFalha(e) });
    }
  }
  return { enviados, falhas };
};
